/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Navigation configuration
  ============================================================

  Varsinaiset FI / EN URL:t tulevat routes.js-tiedostosta.
*/

export const navigationConfig = [
  {
    id: "home",
    routeId: "home",
    labelKey: "pages.home",
  },

  {
    id: "portfolio",
    routeId: "portfolio",
    labelKey:
      "navigation.portfolio",
  },

  {
    id: "services",
    routeId: "services",
    labelKey:
      "navigation.services",
  },

  {
    id: "studio",
    routeId: "studio",

    /*
      Studio on sama sana FI / EN.

      Navbar ja MobileMenu käyttävät i18nextin t()-funktiota.
      Jos avainta ei ole sanastossa, i18next palauttaa avaimen
      sellaisenaan -> "Studio".
    */
    labelKey: "Studio",
  },

  {
    id: "pricing",
    routeId: "pricing",
    labelKey:
      "navigation.pricing",
  },

  {
    id: "about",
    routeId: "about",
    labelKey:
      "navigation.about",
  },

  {
    id: "contact",
    routeId: "contact",
    labelKey:
      "navigation.contact",
  },
];

export default navigationConfig;